import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import './assets/css/style.css';
import './assets/css/nav.css';
import "./assets/css/Header.css";
import './assets/css/powerplant.css';
import './assets/css/category.css';
import './assets/css/privacypolicy.css';
import './index.css';
import './font-awesome/css/font-awesome.min.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import HomePage from './landing_page/home/HomePage';
import CogenPowerplantPage from './landing_page/powerplant/cogenpowerplant/CogenPowerplantPage';
import SupplierPage from './landing_page/suppliers/SupplierPage';
import ClassifiedPage from './landing_page/classifieds/ClassifiedPage';
import ContactPage from './landing_page/contactus/ContactPage';
import AboutUsPage from './landing_page/aboutus/AboutUsPage';
import Navbar from './landing_page/Nav';
import Footer from './landing_page/Footer';
import PrivacyPolicyPage from './landing_page/PrivacyPolicy/PrivacyPolicyPage';
import TermsConditionsPage from './landing_page/TermsConditions/TermsConditionsPage';
import Cogeneration from './landing_page/CogenerationInfo/Cogeneration';
import Supplier from './landing_page/supplier/Supplier';
import PageNotFound from './landing_page/PageNotFound';
import ClassifiedSupplierPage from './landing_page/ClassifiedSuppliers/ClassifiedSupplierPage';
import StateDetail from './landing_page/home/StateDetail';
import Statewise from './landing_page/home/Statewise';
import PowerGenPlantPage from './landing_page/PowerGenPlants/PowerGenPlantPage';
import RenewableAgenciesPage from './landing_page/RenewableAgencies/RenewableAgenciesPage';
import RenewableEnergyPage from './landing_page/RenewableEnergy/RenewableEnergyPage'; 
import PowerGeneration from './landing_page/PowerGenerationPlants/PowerGeneration';
import RenewableAgency from './landing_page/RenewableAgency/RenewableAgency';
import RenewEnergy from './landing_page/RenewEnergy/RenewEnergy';
import DynamicSearch from "./landing_page/home/DynamicSearch";
import SearchResults from "./landing_page/home/SearchResults";
import CogenerationTabs from "./landing_page/CogenerationInfo/CogenerationTabs";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  <div className="app-container"> 
  <Navbar />
  <div className="main-content"> 
  <Routes>
    <Route path="/" element={<HomePage />}></Route>
    <Route path="/cogeneration" element={<CogenPowerplantPage />}></Route>
    <Route path="/suppliers" element={<SupplierPage />}></Route>
    <Route path="/classifieds" element={<ClassifiedPage />}></Route>
    <Route path="/classified/:id" element={<ClassifiedSupplierPage />} />
    <Route path="/contactus" element={<ContactPage />}></Route>
    <Route path="/aboutus" element={<AboutUsPage/>}></Route>
    <Route path="/privacy-policy" element={<PrivacyPolicyPage/>}></Route>
    <Route path="/terms-conditions" element={<TermsConditionsPage />}></Route>
    <Route path="/cogenerationinfo/:plantName/:id" element={<Cogeneration/>} />
   <Route path="/cogen/:id" element={<CogenerationTabs />} />
   <Route path="/supplier/:id/:name" element={<Supplier />} />
    <Route path="/states" element={<Statewise />} />
    <Route path="/state/:stateName" element={<StateDetail />} />
    <Route path="/powergenerationplants" element={<PowerGenPlantPage/>} />
    <Route path="/renewableagenciesindia" element={<RenewableAgenciesPage/>} />
    <Route path="/renewableenergyindia" element={<RenewableEnergyPage/>} />
    <Route path="/powergeneration" element={<PowerGeneration/>} />
    <Route path="/powergeneration/:plantName/:id" element={<PowerGeneration/>} />
    <Route path="/renewableagency/:plantName/:id" element={<RenewableAgency/>} />
    <Route path="/renewableenergy/:plantName/:id" element={<RenewEnergy/>} />
    <Route path="/" element={<DynamicSearch />} />
    <Route path="/search" element={<SearchResults />} />
    <Route path="*" element={<PageNotFound />}></Route>
  </Routes>
  </div>
  <Footer />
  </div>
  </BrowserRouter>
);
